import styled from 'styled-components';
import { fontSizes, fontWeights, lineHeights } from '../../defaultTheme';
const H3 = styled.h3 `
  font-size: ${fontSizes.xLarge}px;
  line-height: ${lineHeights.large};
  font-weight: ${({ weight }) => fontWeights[weight || 'regular']};
  margin: 0;

  &:focus {
    outline: none;
  }
`;
export default H3;
